import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    container: {
        textAlign: 'center',
        padding: theme.spacing(4),
        flexGrow:'1',
        display:'flex',
        flexDirection:'column',
        justifyContent:'center',
        [theme.breakpoints.down('sm')]: {
            padding: '0px',
            paddingTop:'40px',
        },
    },
    title: {
        color: '#FF6900 !important',
        fontWeight: '700 !important',
        marginTop: '50px !important',
        marginBottom: '30px !important',
        fontSize: '35px',
        textAlign: 'center',
    },
    subtitle: {
        color: '#EE6628',
        fontSize: '26px',
    },
    cardHeader:{
        width: '100%',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'flex-start',
        paddingTop:'20px',
        height: '200px',
        backgroundColor: '#FF6900',
        borderBottomLeftRadius: '100% 50px',
        borderBottomRightRadius: '100% 50px',
        overflow: 'hidden',
        position: 'relative',
    },
    card:{
        flex: 1,
        minWidth: 0,
        maxWidth:'340px',
        width:'100%',
        padding:'0px !important',
        position:'relative',
        backgroundColor: '#FEF6E9 !important',
        margin:'25px',
        height:'530px',
        display:'flex',
        flexDirection:'column',
        borderRadius:'15px !important',
        alignItems:'center',
        textAlign:'center',
        [theme.breakpoints.up('lg')]: {
            margin: '9px',
            maxWidth: '380px',
        },
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        alignItems: 'center',
        height: '100%',
        width:'100%',
        padding: '0px !important',
    },
    button: {
        margin: '10px !important',
        backgroundColor: '#FF6900 !important',
        width: '100% !important',
        padding: '10px !important',
        color: '#fff !important',
        fontWeight: '700 !important',
        borderRadius: '8px !important',
        boxShadow: 'none !important',
        '&:hover': {
            backgroundColor: '#c9541e !important',
            color: '#fff !important',
            boxShadow: 'none !important',
        },
        '&.Mui-disabled': {
            backgroundColor: '#BDBDBD !important',
            color: '#fff !important',
        },
        [theme.breakpoints.down('sm')]: {
            margin: '10px 0 !important',
        },
    },
    upgradeButton: {
        position: 'absolute !important',
        top: '0px !important',
        right: '0px !important',
        backgroundColor: '#002060 !important',
        color: '#FFFFFF !important',
        zIndex: 2,
        '&:hover': {
            backgroundColor: '#00153b !important',
        },
    },
    enabledCard: {
        backgroundColor: '#FEF6E9 !important',
        color: '#000',
    },
    activeButton: {
        backgroundColor: '#FF6900 !important',
        color: '#fff !important',
        '&:hover': {
            backgroundColor: '#c9541e !important',
        },
    },

}));

export default useStyles;